import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ConfigService } from '../../services/config.service';
import { Observable } from 'rxjs';
import { PartyRoleRelationship } from '@wdx/clmi/clmi-swagger-gen';

@Injectable()
export class ConnectionsService {
    private http = inject(HttpClient);
    private config = inject(ConfigService);


    getForPartyRole(partyRoleId: string): Observable<PartyRoleRelationship[]> {
        return this.http.get<PartyRoleRelationship[]>(
            `${
                this.config.getConfiguration().API_BASE
            }/partyRole/${partyRoleId}/connections`,
        );
    }
}
